import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { TranslationWithSourceWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';
import LanguageButton from 'components/button/language_button';
import SentenceBreakdown from 'components/sentence_breakdown';
import cx from 'classnames';
import Text from 'components/text';
import { PlayIcon , LanguageIcon } from '@seedlang/icons';
import { DeckUI } from '@seedlang/state';
import { isBlank } from '@seedlang/utils';
import {displayTargetTextCorrectedForLanguage} from '@seedlang/utils/src';
import { isPresent } from '@seedlang/utils';

const Wrapper = styled.div`
  background: ${props => props.background};
  flex: ${props => props.flex};
  display: flex;
  padding: ${props => props.padding || '10px 0'};
  width: 100%;
`;

const LanguageButtonWrapper = styled.div`
  width: ${props => props.languageButtonWrapperWidth || '46px'};
  padding: ${props => props.languageButtonWrapperPadding || '0'};
  display: flex;
  justify-content: flex-end;
`;

const TextWrapper = styled.div`
  flex: 1;
  padding: 0 10px 0 10px;
  display: grid;
`;

const TextLayer = styled.div`
  grid-area: 1 / 1;
  visibility: ${props => props.visible ? 'visible' : 'hidden'};
`;

const PlayButtonWrapper = styled.div`
  width: 22px;
  cursor: pointer;
  .play-icon {
    opacity: 0.8;
  }
  svg {
    width: 22px;
  }
`;

@observer
class TranslationWithSource extends React.Component {
  @observable showType = 'target';

  static defaultProps = {
    flex: '1',
    fontSize: '14px',
    padding: '10px 0',
  };

  render() {
    const hasSentenceBreakdownData = Array.isArray(this.props.translation?.wordAssociations) && this.props.translation.wordAssociations.length > 0;
    const shouldRenderSentenceBreakdown = this.props.showSentenceBreakdown && hasSentenceBreakdownData;
    const sourceText = this.props.translation.sourceTextForUser ? this.props.translation.sourceTextForUser(DeckUI.user) : this.props.translation.sourceText;
    return (
      <Wrapper
        className={cx(this.props.className)}
        background={this.props.background}
        flex={this.props.flex}
        padding={this.props.padding}
      >
        {
          !isBlank(this.props.translation.sourceText) &&
            <LanguageButtonWrapper
              languageButtonWrapperWidth={this.props.languageButtonWrapperWidth}
              languageButtonWrapperPadding={this.props.languageButtonWrapperPadding}
            >
              <LanguageButton
                background={this.props.languageButtonBackground || this.props.background}
                onClick={() => this.showType = this.showType === 'target' ? 'source' : 'target'}
                languageId={this.showType === 'source' ? (this.props.translation.sourceTextForUserLanguageId && this.props.translation.sourceTextForUserLanguageId(DeckUI.user)) || 'EN' : this.props.translation.languageId || 'DE'}
              />
            </LanguageButtonWrapper>
        }
        {
          isBlank(this.props.translation.sourceText) &&
            <LanguageIcon
              languageId={this.props.translation.languageId}
            />
        }
        <TextWrapper>
          <TextLayer visible={this.showType === 'target'}>
            {
              shouldRenderSentenceBreakdown &&
                <SentenceBreakdown
                  {...this.props.sentenceBreakdownProps}
                  fontSize={this.props.fontSize}
                  sentence={this.props.translation}
                />
            }
            {
              !shouldRenderSentenceBreakdown &&
                <Text
                  fontSize={this.props.fontSize}
                >
                  {displayTargetTextCorrectedForLanguage(this.props.normalizedTargetText, this.props.translation.languageId)}
                </Text>
            }
          </TextLayer>
          <TextLayer visible={this.showType === 'source'}>
            <Text
              fontSize={this.props.fontSize}
            >
              {sourceText}
            </Text>
          </TextLayer>
        </TextWrapper>
        {
          this.props.onClickPlayVideo && this.props.translation && isPresent(this.props.translation.target?.videoClip) &&
            <PlayButtonWrapper>
              <PlayIcon
                onClick={() => this.props.onClickPlayVideo(this.props.translation)}
              />
            </PlayButtonWrapper>
        }
      </Wrapper>
    );
  }
}

export default TranslationWithSourceWrapper(TranslationWithSource);
